// extracted by mini-css-extract-plugin
module.exports = {"MainSlider":"SliderViewer_MainSlider__2khOo","NonePointer":"SliderViewer_NonePointer__3obk7"};